export const IS_DEVELOPMENT = import.meta.env.MODE === "development";
